<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="port-main">
    <div id="divMenu">
      <Menus
        :menu="menu"
        icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-location-64.png"
        @menuClicked="menuClicked"
      />
    </div>
    <div class="port-content">
      <!--Big Map-->
      <div id="map-container">
        <CustomMap :viewMode="true" :hideSlot="true" :markers.sync="portMarkers" ref="bigMap" />
      </div>
      <!-- Table -->
      <div class="table-box-container" :style="{ height: showMap ? '40%' : '100%' }">
        <TableBox
          title="Port"
          :dataType="tableDataType"
          :tableData="fullPortList"
          :maxSelection="1"
          :selectedRow.sync="selectedPort"
          :loading="loading"
        />
      </div>
      <!-- Popup -->
      <PopupEntry
        v-if="showPopup"
        :show.sync="showPopup"
        :title="entryTitle"
        @save="savePort"
        :errorMessages.sync="Emessages"
        :successMessages="successMessages"
        :viewMode="viewMode"
        :createdBy="createdBy"
        :updatedBy="updatedBy"
        @update:show="popupClosed"
      >
        <div class="port-code">
          <Input
            placeholder="Port Code"
            :isRequired="true"
            :inputValue.sync="portCode"
            :isDisabled="disabledPortCode"
            :errorMessage.sync="portCodeErr"
          />
          <CheckBox title="Active" :isChecked.sync="portActive" style="padding-left: 10px" :isDisabled="viewMode" />
        </div>
        <Input
          placeholder="Port Location"
          :isRequired="true"
          :inputValue.sync="portLocation"
          :isDisabled="viewMode"
          :errorMessage.sync="portLocationErr"
        />
        <InputQuery
          placeholder="Country Code"
          :isRequired="true"
          :items="countryCodeItems"
          itemKey="Country Code - Description"
          descKey="Country"
          :selectedObject.sync="selectedCountryCode"
          :isDisabled="viewMode"
          :errorMessage.sync="countryCodeErr"
        />
        <div class="flex-row" style="align-items: flex-start">
          <div class="port-location">
            <Input
              placeholder="Latitude"
              :inputValue.sync="portLat"
              :isRequired="true"
              textType="number"
              :isDisabled="viewMode"
              :errorMessage.sync="portLatErr"
              @inputChanged="latLngInputChanged"
            />
            <Input
              placeholder="Longitude"
              :inputValue.sync="portLng"
              :isRequired="true"
              textType="number"
              :isDisabled="viewMode"
              :errorMessage.sync="portLngErr"
              @inputChanged="latLngInputChanged"
            />
            <!-- <Input 
              placeholder="Height" 
              :inputValue.sync="portHeight" 
              textType="number" 
              :isDisabled="viewMode" 
            /> -->
            <Button style="margin-top: 5px; width: 100%" @click="updateLocationFromMarker" :disabled="viewMode">
              Update Location from Marker
            </Button>
          </div>
          <CustomMap
            style="width: 60%; height: 375px"
            :markers.sync="popupMarker"
            ref="popupMap"
            :slotFloat="true"
            :maxMarkerCount="1"
            :viewMode="viewMode"
          />
        </div>
      </PopupEntry>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: false, //Loading Screen
      menu: [
        {
          title: 'New Port',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: false,
        },
        {
          title: 'Edit Port',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: false,
        },
        {
          title: 'Delete Port',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: false,
        },
        {
          title: 'View Port',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: false,
        },
        {
          title: 'Show Map',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/Map.png',
        },
      ],

      //#region Table
      fullPortList: [], //Full detailed list
      tableDataType: {
        'Updated on': 'datetime',
      },
      showMap: false,
      selectedPort: [], //Selected row on table
      portMarkers: [],
      //#endregion

      //#region Popup Form
      showPopup: false, //Popup on/off
      entryTitle: '', //Popup Form Title
      updatedBy: '',
      createdBy: '',
      successMessages: [],
      Emessages: [],
      portAction: '',
      //#endregion

      //#region Popup Content
      portCode: '',
      portActive: false,
      portLocation: '',
      countryCodeItems: [],
      selectedCountryCode: null,
      portLat: '',
      portLng: '',
      // portHeight: '',
      viewMode: false,
      disabledPortCode: false,
      popupMarker: [],

      portCodeErr: '',
      portLocationErr: '',
      countryCodeErr: '',
      portLatErr: '',
      portLngErr: '',
      //#endregion
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=Master&page=Port`);
      sasControl.forEach((k) => {
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading('');
    },
    //Button Actions
    menuClicked: function (e) {
      switch (e.title) {
        case 'New Port':
          this.newClicked();
          break;
        case 'Edit Port':
          this.viewEditClicked('edit');
          break;
        case 'Delete Port':
          this.deleteClicked();
          break;
        case 'View Port':
          this.viewEditClicked('view');
          break;
        case 'Show Map':
          this.$set(this.menu[4], 'title', 'Hide Map');
          this.$set(this.menu[4], 'icon', 'https://dsmapi.logistics.systems/dsm6gicons/MapHide.png');
          this.showMap = true;
          break;
        case 'Hide Map':
          this.$set(this.menu[4], 'title', 'Show Map');
          this.$set(this.menu[4], 'icon', 'https://dsmapi.logistics.systems/dsm6gicons/Map.png');
          this.showMap = false;
          break;
      }
    },
    newClicked: function () {
      this.clearForm();
      this.disabledPortCode = false;
      this.entryTitle = 'New Port';
      this.showPopup = true;
      this.portAction = 'N';
    },
    deleteClicked: async function () {
      if (!this.selectedPort[0]) {
        this.$showAlert('error', 'No Port Selected', 'Please select a record to delete');
      } else {
        const isDelete = await this.$showAlert(
          'warning',
          'Delete Port',
          `Are you sure you want to delete port ${this.selectedPort[0]['Port Code']}?`,
          [
            { text: 'Delete', color: 'red', textColor: 'white' },
            { text: 'Cancel', color: 'lightgray' },
          ],
        );
        if (isDelete === 'Delete') {
          const dataToPost = {
            action: 'D',
            Port_code: this.selectedPort[0]['Port Code'],
          };

          this.$fullscreenLoading('Deleting Port');
          const postUpdate = await this.$apiCallV2('/Port/SavePort', dataToPost);
          this.$fullscreenLoading();

          if (postUpdate[0].Results == 0) {
            this.$showAlert('success', 'Delete', 'Port Deleted');
            this.selectedPort = [];
            this.getAllPorts();
          } else {
            this.$showAlert('error', 'Delete', 'Port NOT Deleted');
          }
        }
      }
    },
    viewEditClicked: function (status) {
      if (!this.selectedPort[0]) {
        this.$showAlert('error', 'No Port Selected', `Please select a record to ${status}`);
      } else {
        this.retrieveTablePort();
        this.disabledPortCode = true;
        if (status == 'edit') {
          this.entryTitle = 'Edit Port';
          this.showPopup = true;
          this.portAction = 'E';
        } else {
          this.viewMode = true;
          this.entryTitle = 'View Port';
          this.showPopup = true;
        }
      }
    },
    //Save Port
    savePort: async function () {
      this.$fullscreenLoading('Saving');

      if (this.checkFields()) {
        this.$fullscreenLoading();
        return;
      }
      //Round to 10 decimal places to prevent lat/long from going over the character limit (15).
      this.portLat = (Math.round(this.portLat * 10000000000) / 10000000000).toString();
      this.portLng = (Math.round(this.portLng * 10000000000) / 10000000000).toString();
      const timeNow = new Date().formatString('yyyy-MM-dd HH:mm:ss');

      const dataToPost = {
        action: this.portAction,
        lastupdate: timeNow,
        Port_code: this.portCode,
        Port_Location: this.portLocation,
        Country_code: this.selectedCountryCode['Country Code'],
        Latitude: this.portLat,
        Longitude: this.portLng,
        Active: this.portActive ? '1' : '0',
      };
      const postUpdate = await this.$apiCallV2('/Port/SavePort', dataToPost);
      if (postUpdate[0].Results == 1) {
        this.Emessages.push(postUpdate[0].ErrMsg);
      } else {
        this.successMessages.push('Successfully saved Port!');
        this.viewMode = true;
        this.getAllPorts();
      }
      this.$fullscreenLoading();
    },
    //Retrieve from table
    retrieveTablePort: async function () {
      this.clearForm();
      this.$fullscreenLoading('Getting Details');
      const portDetails = (
        await this.$apiCallV2(`/Port/GetDetailsMaster?recordID=${this.selectedPort[0]['Port Code']}`)
      )['Port'];
      this.$fullscreenLoading();

      // Port details
      const dateUpdated =
        new Date(portDetails['DateUpdated']) ?
          new Date(portDetails['DateUpdated']).formatString('yyyy/MM/dd HH:mm:ss')
        : '';
      this.createdBy = portDetails['UserID'];
      this.updatedBy = `${this.createdBy} ${dateUpdated}`;
      this.portCode = portDetails['Port_code'];
      this.portActive = portDetails['Active'] == 1;
      this.portLocation = portDetails['Port_Location'];
      this.selectedCountryCode = this.countryCodeItems.getSelected(portDetails['Country_Code'], 'Country Code');
      this.portLat = portDetails['Latitude'];
      this.portLng = portDetails['Longitude'];

      // Place marker on map
      if (this.portLat && this.portLng) {
        const latLng = `${this.portLat}, ${this.portLng}`;
        this.$refs['popupMap'].getMarkerByLatLng(latLng);
      }
    },
    checkFields: function () {
      this.Emessages = [];
      this.successMessages = [];

      if (!this.portCode) {
        this.portCodeErr = 'Port Code is required!';
        this.Emessages.push(this.portCodeErr);
      } else if (this.portCode.length > 5) {
        this.portCodeErr = 'Port Code cannot exceed 5 characters!';
        this.Emessages.push(this.portCodeErr);
      }
      if (!this.portLocation) {
        this.portLocationErr = 'Port Location is required!';
        this.Emessages.push(this.portLocationErr);
      } else if (this.portLocation.length > 40) {
        this.portLocationErr = 'Port Location cannot exceed 40 characters!';
        this.Emessages.push(this.portLocationErr);
      }
      if (!this.selectedCountryCode) {
        this.countryCodeErr = 'Country Code is required!';
        this.Emessages.push(this.countryCodeErr);
      }
      if (isNaN(parseFloat(this.portLat))) {
        this.portLatErr = 'Latitude is invalid!';
        this.Emessages.push(this.portLatErr);
      } else if (this.portLat.length > 15) {
        this.portLatErr = 'Latitude cannot exceed 15 characters!';
        this.Emessages.push(this.portLatErr);
      }
      if (isNaN(parseFloat(this.portLng))) {
        this.portLngErr = 'Longitude is invalid!';
        this.Emessages.push(this.portLngErr);
      } else if (this.portLat.length > 15) {
        this.portLngErr = 'Longitude cannot exceed 15 characters!';
        this.Emessages.push(this.portLngErr);
      }

      return this.Emessages.length > 0;
    },
    clearForm: function () {
      this.successMessages = [];
      this.Emessages = [];
      this.viewMode = false;
      this.updatedBy = '';
      this.createdBy = '';

      this.portCode = '';
      this.portActive = false;
      this.portLocation = '';
      this.selectedCountryCode = null;
      this.portLat = '';
      this.portLng = '';
      this.popupMarker = [];

      this.portCodeErr = '';
      this.portLocationErr = '';
      this.countryCodeErr = '';
      this.portLatErr = '';
      this.portLngErr = '';
    },
    //Initial Mount Data
    getAllPorts: async function () {
      this.loading = true;
      this.fullPortList = [];
      this.fullPortList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' });
      this.mountMarkerList();
      this.loading = false;
    },
    mountMarkerList: function () {
      this.fullPortList.forEach((port) => {
        const lat = port['Latitude'];
        const lng = port['Longitude'];
        if (lat && lng) {
          this.$refs['bigMap'].addMarker({
            lat: parseFloat(lat),
            lng: parseFloat(lng),
          });
        }
      });
    },
    popupClosed: async function (val) {
      if (!val && this.$route.query['new'] && !this.viewMode) {
        // When the cancel is click but is not saved (for query new=1)
        const closeWindow = await this.$showAlert(
          'warning',
          'Cancelling Port Creation',
          `You have not created a Port profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`,
          [{ text: 'Continue Creating' }, { text: 'Cancel Creating', color: 'red', textColor: 'white' }],
        );

        if (closeWindow == 'Cancel Creating') {
          // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.showPopup = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    },
    // Update lat/lng from placed marker
    updateLocationFromMarker: function () {
      if (this.popupMarker.length != 0) {
        const lat = this.popupMarker[0]['position']['lat'];
        const lng = this.popupMarker[0]['position']['lng'];
        this.portLat = (Math.round(lat * 10000000000) / 10000000000).toString();
        this.portLng = (Math.round(lng * 10000000000) / 10000000000).toString();
      }
    },
    // Place marker from input lat lng
    latLngInputChanged: function () {
      const latLng = `${this.portLat}, ${this.portLng}`;
      this.$refs['popupMap'].getMarkerByLatLng(latLng);
    },
  },
  watch: {},
  mounted: async function () {
    await this.sasControlFunction();

    const mountedPromises = [];
    let promisesFulfilled = 0;

    mountedPromises.push(
      this.getAllPorts().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' }).then((result) => {
        const countryCodes = this.$deepTrimJsonV3(result);
        this.countryCodeItems = countryCodes.map((item) => {
          return {
            ...item,
            'Country Code - Description': `${item['Country Code']} - ${item['Country']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    await Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });

    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Port' });
    }
  },
};
</script>

<style lang="scss" scoped>
.port-main {
  width: 100%;
  height: 100%;
  padding: 3px 45px;
  overflow: hidden;
  display: flex;
  font-size: 12px;

  > .port-content {
    display: flex;
    flex-direction: column;
    width: auto;
    height: auto;
    flex: 1;
    padding-left: 5px;
    width: 100%;
    height: 100%;

    > #map-container {
      width: 100%;
      flex: 1;
    }

    > .table-box-container {
      padding: 5px;
      background-color: white;
      border-radius: 5px;
      height: 100%;
      width: 100%;
      margin-top: 5px;
      transition: 0.3s;
    }
  }
}

.port-code {
  display: flex;
  flex-direction: row;
}

.port-location {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  align-items: center;

  > * {
    width: 50%;
  }

  > :not(:first-child) {
    margin-left: 5px;
  }
}
</style>
